import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const ROOT_DIV_ID = "sodo-search-root";

function getSiteData() {
  const scriptTag = document.querySelector("script[data-sodo-search]");
  if (scriptTag && scriptTag instanceof HTMLScriptElement) {
    const adminUrl = scriptTag.dataset.sodoSearch;
    const apiKey = window.ghostApiKey ?? import.meta.env.VITE_GHOST_API_KEY ?? "";
    const stylesUrl = scriptTag.dataset.styles;
    return { adminUrl, apiKey, stylesUrl };
  }
  return {};
}

function init() {
  const { adminUrl, apiKey, stylesUrl } = getSiteData();
  const adminBaseUrl = (adminUrl || window.location.origin)?.replace(
    /\/+$/,
    "",
  );

  const rootDiv = document.createElement("div");
  rootDiv.id = ROOT_DIV_ID;
  document.body.appendChild(rootDiv);

  createRoot(rootDiv).render(
    <StrictMode>
      <App adminUrl={adminBaseUrl} apiKey={apiKey} stylesUrl={stylesUrl} />
    </StrictMode>,
  );
}

init();
